import API from '../../api';
import {
    CHANGE_PASSWORD_START,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
} from './actionTypes';
import { message } from 'shared/constant'
import { pushNotification } from 'utils/notification';

// export function changePasswordRequest(action) {
//     return async function(dispatch) {
//         dispatch(changePasswordStart());
//         const data = {
//             currentPassword: action.currentPassword,
//             newpassword: action.password
//         };
//         try {
//             const response = API.post('/accounts/change-password', data);
//             if(response) {
//                 dispatch(changePasswordSuccess());
//                 action.reset && action.reset()
//                 // pushNotification(message.PASSWORD_CHANGE_SUCCESS, 'success', 'TOP_RIGHT', 3000);
//                 console.log('work')
//             }
               
//         } catch(error) {
//             pushNotification(error.response.data, 'error', 'TOP_RIGHT', 3000);            
//             dispatch(changePasswordFail());
//         }
//     };
// };

export function changePasswordRequest(action) {
    return async function(dispatch) {
        dispatch({
            type: CHANGE_PASSWORD_START
        });
        try {
            const response = await API.post('/accounts/change-password', action);
            if(response) {
                dispatch({
                    type: CHANGE_PASSWORD_SUCCESS
                });
                pushNotification(message.PASSWORD_CHANGE_SUCCESS, 'success', 'TOP_RIGHT', 3000);
            }
        } catch(error) {
                pushNotification(error.response.data.message, 'error', 'TOP_RIGHT', 3000)       
                dispatch({
                    type: CHANGE_PASSWORD_FAILURE
                });
        }
       
    }
}
